import { createStyles } from '@mui/styles';
import { Theme } from '~/themes';

const style = (theme: Theme) =>
  createStyles({
    root: {
      width: 32,
      height: 20,
      padding: 0,
      marginBottom: 0.5,
    },
    rootNoText: {
      width: 32,
    },
    switchBase: {
      'padding': 0,
      'top': 2,
      'left': 2,
      '&.Mui-checked': {
        'transform': 'translateX(12px)',
        '& + .MuiSwitch-track': {
          backgroundColor: '#4caf50',
          opacity: 1,
          border: 'none',
        },
      },
    },
    switchBaseNoText: {
      '&.Mui-checked': {
        transform: 'translateX(12px)',
      },
    },
    thumb: {
      color: theme.color.white,
      width: 16,
      height: 16,
    },
    track: {
      'borderRadius': 30,
      'backgroundColor': theme.color.violet600,
      'opacity': 1,
      '&::after': {
        content: '"OFF"',
        position: 'absolute',
        fontSize: 14,
        top: 8,
        left: 36,
        color: theme.color.white,
      },
    },
    disabled: {
      '&$checked + $track': {
        opacity: '0.5 !important',
      },
    },
    trackNoText: {
      '&::before, &::after': {
        display: 'none',
      },
    },
    formRoot: {
      margin: 0,
    },
    formLabel: {
      marginLeft: theme.spacing(1),
    },
    legend: {
      color: theme.palette.text.primary,
      fontSize: 12,
      marginBottom: theme.spacing(0),
      marginRight: theme.spacing(0.6),
    },
  });

export default style;
